module.exports = __webpack_public_path__ + "static/media/IconTemplates_-61.dc9582b2.svg";